import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { colors } from 'ui/theme';
import { useAssetManagerContext } from '../contexts/BaseAssetManagerContext';
import { AssetManagerSidebarList } from './AssetManagerSidebarList';

const StyledModalBody = styled(ModalBody)`
  background-color: ${colors.backgroundPrimary};
  display: flex;
  height: 100vh;
`;

const FormWrapper = styled.div`
  overflow: visable;
  flex-grow: 1;
`;

type AssetManagerModalProps = {
  id: string;
  onClose: () => void;
  Header?: FC<React.PropsWithChildren<unknown>>;
  SidebarList?: FC<React.PropsWithChildren<unknown>>;
  ListEntry?: FC<React.PropsWithChildren<{ asset: any; onClick: () => void; className: string }>>;
  AssetForm: FC<React.PropsWithChildren<unknown>>;
  BottomActions?: FC<React.PropsWithChildren<unknown>>;
  children?: ReactNode;
};

export const AssetManagerModal = ({
  id,
  children,
  onClose,
  Header,
  SidebarList,
  ListEntry,
  AssetForm,
  BottomActions,
}: AssetManagerModalProps) => {
  const { assetTypeName, handleClose } = useAssetManagerContext();

  return (
    <Modal
      id={`${id}-manage-asset-modal`}
      isModalOpen={true}
      onClose={() => handleClose(onClose)}
      size={MODAL_SIZES.LARGE}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      {Header ? <Header /> : assetTypeName && <ModalHeader>{`${assetTypeName}s`}</ModalHeader>}
      <StyledModalBody>
        {ListEntry && <AssetManagerSidebarList ListEntry={ListEntry} />}
        {!ListEntry && SidebarList && <SidebarList />}
        <FormWrapper>
          <AssetForm />
        </FormWrapper>
        {children}
      </StyledModalBody>
      {BottomActions ? <BottomActions /> : <ModalFooter hasCancel={false} />}
    </Modal>
  );
};
